function setUpTruncateComponent(
  location: string,
  visibleLines: number,
  breakpointsWithTruncationBehavior: string[],
) {
  const BREAKPOINTS = {
    small: { max: 567 },
    medium: { min: 568, max: 1279 },
    large: { min: 1280 },
  };
  const truncationButtonSelector = `.js-toggle-truncation-button--${location}`;
  const truncationComponentSelector = `.js-truncate-component--${location}`;
  const truncationComponent: HTMLElement | null = document.querySelector(
    truncationComponentSelector,
  );
  const truncationButton: HTMLElement | null = document.querySelector(
    truncationButtonSelector,
  );

  if (!truncationComponent || !truncationButton) return;

  const getCurrentBreakpoint = () => {
    const width = window.innerWidth;
    if (width < BREAKPOINTS.medium.min) return 'small';
    if (width < BREAKPOINTS.large.min) return 'medium';
    return 'large';
  };

  const readMoreButton = truncationButton.querySelector<HTMLElement>(
    `.js-read-more-button--${location}`,
  );
  const readLessButton = truncationButton.querySelector<HTMLElement>(
    `.js-read-less-button--${location}`,
  );

  const handleSetUpTruncationBehavior = () => {
    if (!truncationButton) return;
    // consider the truncation component to be fully expanded if the scroll height is within 3px of the client height
    if (
      truncationComponent.scrollHeight <=
      truncationComponent.clientHeight + 3
    )
      return;

    truncationButton.style.display = 'block';
    truncationComponent.style.display = '-webkit-box';
    truncationComponent.style.webkitLineClamp = visibleLines.toString();

    if (readMoreButton && readLessButton) {
      readMoreButton.addEventListener('click', () => {
        truncationComponent.style.display = 'block';
        readMoreButton.style.display = 'none';
        readLessButton.style.display = 'block';
      });
      readLessButton.addEventListener('click', () => {
        truncationComponent.style.display = '-webkit-box';
        truncationComponent.style.webkitLineClamp = visibleLines.toString();
        readMoreButton.style.display = 'block';
        readLessButton.style.display = 'none';
      });
    } else {
      truncationButton.addEventListener('click', () => {
        truncationComponent.style.display = 'block';
        truncationButton.style.display = 'none';
      });
    }
  };

  const handleCleanUpTruncationBehavior = () => {
    if (!truncationButton) return;
    truncationButton.style.display = 'none';
  };

  const updateTruncationBehavior = () => {
    const currentBreakpoint = getCurrentBreakpoint();

    if (breakpointsWithTruncationBehavior.includes(currentBreakpoint)) {
      handleSetUpTruncationBehavior();
    } else {
      handleCleanUpTruncationBehavior();
    }
  };

  updateTruncationBehavior();

  let resizeTimeout: NodeJS.Timeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(updateTruncationBehavior, 250);
  });
}

export { setUpTruncateComponent };
